import {
    Box,
    Card,
    CardContent,
    Typography,
} from '@mui/material';

import DateFormat from '../../utils/DateFormat';
import { useTranslation } from 'react-i18next';

function FlexTimeAccountBalance({ balance }) {
    const {t} = useTranslation();
    
    return (
        <Card sx={{ height: 'fit-content', pt: 1, px: 3, }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                    {t('aktuellesArbeitszeitkonto', {ns : 'dashboardPage', defaultValue : 'Aktuelles Arbeitszeitkonto'})} 
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold', color : balance < 0 ? 'red' : 'green' }}>
                        {DateFormat.formatDuration(balance)}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default FlexTimeAccountBalance
